/** Plan active/inactive state (aligned with coverage status mapping in the EVBV flow). */
export enum CoveragePlanDisplayStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  UNKNOWN = "unknown",
}

export enum CoverageSubscriberType {
  INDIVIDUAL = "individual",
  FAMILY = "family",
}

export enum CoverageMiscellaneousAmountType {
  CO_INSURANCE = "co-insurance",
  CO_PAY = "co-pay",
}
